import axios from 'axios'

class API {
    constructor (baseUrl) {
        this._http = axios.create({
            baseURL: baseUrl,
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
        this.debug = true
    }

    async AmfRequest (filename, method, params) {
        let requestResult = await this._http.post('/gateway_vue.php', {
            serviceName: filename,
            methodName: method,
            parameters: params
        })

        if (this.debug) {
            console.log(requestResult)
        }

        return requestResult
    }
}

export default API
